"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentWithMarker = void 0;
var CommentUtils_1 = require("Project/QwilrEditor/Comments/CommentUtils");
var react_1 = __importDefault(require("react"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var CommentBehaviours_1 = require("Project/QwilrEditor/Behaviours/CommentBehaviours");
var slate_react_1 = require("slate-react");
var Comment_1 = __importDefault(require("Project/QwilrEditor/Comments/Comment"));
var CommentWithMarker = (function (_super) {
    __extends(CommentWithMarker, _super);
    function CommentWithMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentWithMarker.prototype.componentWillUnmount = function () {
        var _a = this.props, mark = _a.mark, commentThreadStore = _a.commentThreadStore, widgetManager = _a.widgetManager;
        var id = mark.data.id;
        var commentGroupStore = commentThreadStore.commentThreadsById[id];
        if (commentGroupStore) {
            var eventData = {
                action: CommentBehaviours_1.CommentWidgetActionType.RecoverMarker,
                id: commentGroupStore._id,
            };
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(CommentBehaviours_1.CommentWidgetName, eventData));
        }
    };
    CommentWithMarker.prototype.render = function () {
        var _a = this.props, mark = _a.mark, children = _a.children, text = _a.properties.text, isCommentsFeatureOn = _a.isCommentsFeatureOn, commentThreadStore = _a.commentThreadStore, user = _a.user, usersInAccount = _a.usersInAccount, mentionsEnabled = _a.mentionsEnabled, editorElem = _a.editorElem, projectId = _a.projectId, permissionsStore = _a.permissionsStore, pendingUsersDataStore = _a.pendingUsersDataStore, inviteNewUser = _a.inviteNewUser, widgetManager = _a.widgetManager;
        var editor = widgetManager.editor;
        if (!isCommentsFeatureOn) {
            return children;
        }
        var endPoint = { path: slate_react_1.ReactEditor.findPath(editor, text), offset: text.text.length };
        var endOfComment = (0, CommentUtils_1.atEndOfComment)(mark, endPoint, editor);
        return (react_1.default.createElement(Comment_1.default, { id: mark.data.id, commentThreadStore: commentThreadStore, user: user, usersInAccount: usersInAccount, showMarker: endOfComment, mentionsEnabled: mentionsEnabled, editorElem: editorElem, projectId: projectId, permissionsStore: permissionsStore, pendingUsersDataStore: pendingUsersDataStore, inviteNewUser: inviteNewUser }, children));
    };
    return CommentWithMarker;
}(react_1.default.Component));
exports.CommentWithMarker = CommentWithMarker;
